import type { MethodStep } from './schema'

/** My method: the three jobs my work does for a client, in order. It names the steps of the Home automation diagram. */
export const method = {
  eyebrow: 'My Method',
  title: 'Map. Build. Run.',
  summary: 'I map what repeats, build the workflows that take it over, and keep them running.',
  steps: [
    {
      name: 'Map',
      body: 'I walk through your current process and find what repeats.',
      inputs: ['Process audit', 'Bottleneck review', 'Tool inventory', 'Data check'],
    },
    {
      name: 'Build',
      body: 'I build the workflows, connect your apps, and add AI where it pays.',
      inputs: ['n8n / Make / Zapier', 'API integrations', 'AI agents', 'CRM & email flows'],
    },
    {
      name: 'Run',
      body: 'I monitor, fix and document, so it keeps working without you watching.',
      inputs: ['Monitoring', 'Error handling', 'Documentation', 'Team handover'],
    },
  ] satisfies MethodStep[],
}
